import { render, staticRenderFns } from "./GalleryFreePrivate.vue?vue&type=template&id=649a06d8&"
import script from "./GalleryFreePrivate.vue?vue&type=script&lang=js&"
export * from "./GalleryFreePrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports